import { render, staticRenderFns } from "./Registrations.vue?vue&type=template&id=442809f0&scoped=true"
import script from "./Registrations.vue?vue&type=script&lang=js"
export * from "./Registrations.vue?vue&type=script&lang=js"
import style0 from "./Registrations.vue?vue&type=style&index=0&id=442809f0&prod&scoped=true&lang=css"
import style1 from "./Registrations.vue?vue&type=style&index=1&id=442809f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442809f0",
  null
  
)

export default component.exports